import axios from 'axios';

const API_URL = process.env.API_URL;

export async function login(user) {
  const url = `${API_URL}/webclient/auth/login`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function connectSocial(user) {
  const url = `${API_URL}/webclient/auth/connect-socmed`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function mobileLogin(token) {
  const url = `${API_URL}/webclient/auth/mobile-login`;
  return axios({ url,
    method: 'get',
    headers: { Authorization: `Bearer ${token}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export function logout(accessToken, accessType) {
  const url = `${API_URL}/webclient/auth/logout`;
  return axios.post(url, null, {
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function register(user) {
  const url = `${API_URL}/webclient/auth/register`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function forgotPassword(user) {
  const url = `${API_URL}/webclient/auth/forgot-password`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function changePassword(user) {
  const url = `${API_URL}/dashboard/auth/change-password`;
  return axios.post(url, user).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailUser(authorization) {
  const url = `${API_URL}/webclient/account/profile`;
  return axios({ url,
    method: 'get',
    headers: { Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function resendVerify(email) {
  const url = `${API_URL}/webclient/auth/resend-activation`;
  return axios({ url,
    method: 'post',
    data:email,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function acceptToc(email, authorization) {
  const url = `${API_URL}/dashboard/auth/accept-toc`;
  return axios({
    url,
    method: 'post',
    data: { email },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getCountry() {
  const url = `${API_URL}/api/country`;
  return axios({ url,
    method: 'get' }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export const authService = {
  login,
  logout,
  register,
};



// WEBPACK FOOTER //
// ./src/services/auth.js